module.exports = __webpack_public_path__ + "static/media/2p_room.797dfc84.svg";